import { Store } from '@ngxs/store';
import {ChangeDetectionStrategy, Component, effect, inject} from '@angular/core';
import {MatButton, MatIconButton} from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { CloseMenu, MenuState } from '../../core/state';
import { isEnterOrSpaceKey } from '../../shared/utils';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, MatIconButton, RouterLink],
})
export class SidebarComponent {
  private readonly store = inject(Store);

  menuItems = this.store.selectSignal(MenuState.menuItems);

  constructor() {
    effect(() => {
      console.log(this.menuItems())
    });
  }


  onCloseSideNavClick(): void {
    this.store.dispatch(new CloseMenu());
  }

  onCloseSideNavKeyDown(event: KeyboardEvent): void {
    if (isEnterOrSpaceKey(event)) {
      this.onCloseSideNavClick();
    }
  }
}
